import {ReactNode} from 'react';

import {buildUrl} from '@dms/routes';
import {useGetUserOptions, usePermissions} from '@dms/shared';

import {DataGridConfigProvider} from 'features/datagrid';
import {EagGridConfigProvider} from 'features/eag-grid';

import {entityResourceResolver} from '../../utils/entityResourceResolver';
import {useDownloadExportedFiles} from './hooks/useDownloadExportedFiles';

type DataGridContainerProps = {
  children: ReactNode;
};

//  This is AG Grid Enterprise License for production environment
const AG_GRID_LICENSE_KEY = process.env.AG_GRID_LICENSE_KEY;

export function DataGridContainer(props: DataGridContainerProps) {
  const {handleExportSuccessfullyStarted} = useDownloadExportedFiles();

  return (
    <DataGridConfigProvider
      value={{
        entityResourceResolver,
        agGridEnterpriseLicenseKey: AG_GRID_LICENSE_KEY,
        buildAbsoluteUrl: buildUrl,
        useGetUserOptions,
        usePermissions,
        handleExportSuccessfullyStarted,
      }}
    >
      <EagGridConfigProvider
        value={{
          buildAbsoluteUrl: buildUrl,
          useGetUserOptions,
          usePermissions,
          handleExportSuccessfullyStarted,
        }}
      >
        {props.children}
      </EagGridConfigProvider>
    </DataGridConfigProvider>
  );
}
